var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2734H0V0.726562H12V11.2734ZM0.703125 10.5703H11.2969V1.42969H0.703125V10.5703Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42969 7.75781H3.53906V8.46094H1.42969V7.75781Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42969 4.98047H3.53906V5.68359H1.42969V4.98047Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42969 6.35156H10.5703V7.05469H1.42969V6.35156Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94531 7.75781H7.05469V8.46094H4.94531V7.75781Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 7.75781H10.5703V8.46094H8.46094V7.75781Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42969 9.16406H3.53906V9.86719H1.42969V9.16406Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94531 9.16406H7.05469V9.86719H4.94531V9.16406Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 9.16406H10.5703V9.86719H8.46094V9.16406Z",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18364 2.07109H4.76958C4.55212 2.07109 4.37505 2.24817 4.37505 2.46562V5.33203C4.37505 5.54949 4.55212 5.72656 4.76958 5.72656H7.18364C7.4011 5.72656 7.57817 5.54949 7.57817 5.33203V2.46562C7.57817 2.24817 7.4011 2.07109 7.18364 2.07109ZM6.78911 4.9375H5.16646V2.86016H6.78911V4.9375Z",
    fill: "#0E2517",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48516 2.07109H1.77422C1.55676 2.07109 1.37969 2.24817 1.37969 2.46562V3.84375C1.37969 4.06121 1.55676 4.23828 1.77422 4.23828H3.48516C3.70261 4.23828 3.87969 4.06121 3.87969 3.84375V2.46562C3.87969 2.24817 3.70261 2.07109 3.48516 2.07109ZM3.09063 3.45156H2.16875V2.8625H3.09063V3.45156Z",
    fill: "#0E2517",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95623 2.12109V2.07109H8.90623H8.21716H8.16716V2.12109V2.81016V2.86016H8.21716H8.90623H8.95623V2.81016V2.12109Z",
    fill: "#0E2517",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3367 2.12109V2.07109H10.2867H9.59766H9.54766V2.12109V2.81016V2.86016H9.59766H10.2867H10.3367V2.81016V2.12109Z",
    fill: "#0E2517",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-outside-1_2_60",
    maskUnits: "userSpaceOnUse",
    x: 7.21716,
    y: 2.25073,
    width: 2,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7.21716,
    y: 2.25073,
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90623 5.09292V3.25073H8.21716V5.09292"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.90623 5.09292V3.25073H8.21716V5.09292",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90623 3.25073H9.00623V3.15073H8.90623V3.25073ZM8.21716 3.25073V3.15073H8.11716V3.25073H8.21716ZM9.00623 5.09292V3.25073H8.80623V5.09292H9.00623ZM8.90623 3.15073H8.21716V3.35073H8.90623V3.15073ZM8.11716 3.25073V5.09292H8.31716V3.25073H8.11716Z",
    fill: "black",
    mask: "url(#path-14-outside-1_2_60)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-16-outside-2_2_60",
    maskUnits: "userSpaceOnUse",
    x: 8.59766,
    y: 2.25073,
    width: 2,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.59766,
    y: 2.25073,
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2867 5.09292V3.25073H9.59766V5.09292"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.2867 5.09292V3.25073H9.59766V5.09292",
    fill: "#0E2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2867 3.25073H10.3867V3.15073H10.2867V3.25073ZM9.59766 3.25073V3.15073H9.49766V3.25073H9.59766ZM10.3867 5.09292V3.25073H10.1867V5.09292H10.3867ZM10.2867 3.15073H9.59766V3.35073H10.2867V3.15073ZM9.49766 3.25073V5.09292H9.69766V3.25073H9.49766Z",
    fill: "black",
    mask: "url(#path-16-outside-2_2_60)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/Dashboard_Icon.1dff28c5e60580614489b559024c3525.svg";
export { ForwardRef as ReactComponent };